/**
 * Deterministic Mini-Project HSE sub-KPI configs (DEV-1141).
 *
 * Identical to what MiniProjectsController provisions and migration 235
 * backfills (Health=streak/quarter, Safety=count/month, Environment=
 * streak/year). Shared by:
 *   - MiniProjectMissionTab (renders the HSERow from computeHseBundle)
 *   - ProgressTab (floor-caps the Mission + Summary nav-tab colors)
 *
 * Built client-side so neither surface needs a second round trip for
 * kpi_config — the FP engine falls back to these same defaults when
 * mission_type_config is absent. display_name stays English to match the
 * stored FP HSE card data (it's data, rendered by HSECard chrome, not a
 * JSX literal). Order is locked Health → Safety → Environment.
 */

import type { IncidentCountConfig } from '../../kpi-engine/missionTypes/incidentCount';

export const MP_HSE_CONFIGS: Array<{ sub_kpi_guid: string; config: IncidentCountConfig }> = [
  {
    sub_kpi_guid: 'health',
    config: {
      display_name: 'Health',
      hse_category: 'health',
      display_mode: 'streak',
      period: 'quarter',
    },
  },
  {
    sub_kpi_guid: 'safety',
    config: {
      display_name: 'Safety',
      hse_category: 'safety',
      display_mode: 'count',
      period: 'month',
    },
  },
  {
    sub_kpi_guid: 'environment',
    config: {
      display_name: 'Environment',
      hse_category: 'environment',
      display_mode: 'streak',
      period: 'year',
    },
  },
];
